'use strict';

var Radio = require('backbone.radio');

var polyglot = require('../../utilities/polyglot').default;

var ButtonView = require('./button').default;

export default ButtonView.extend({

  initialize: function (options) {
    this.text = polyglot.t('nav.reschedule_appointment');
  },

  onRender: function () {
    Radio.channel('buttons').reply('update:disable', this.disable, this);
    Radio.channel('buttons').reply('update:enable', this.enable, this);
  },

  onClick: function (evt) {
    evt.preventDefault();
    Radio.channel('steps').trigger('click:update');
    this.$el.blur();
    this.trigger('click');
  },

  shouldShow: function () {
    return Radio.channel('steps').request('enabled')
           && Radio.channel('reschedule').request('here');
  },

});
